import { inject, Injectable, Signal, signal } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';
import { Message } from 'src/app/models/message/message.model';
import { ApiService } from '../api/api.service';
import { MessageApiService } from './message-api.service';
import { CriticalMessage } from 'src/app/models/message/critical-message.model';

@Injectable({
    providedIn: 'root',
})
export class MessageService extends ApiService<Message> {
    private readonly messageApiService = inject(MessageApiService);

    private readonly bannerMessages = signal<Message[]>([]);
    private readonly notifyMessages = signal<Message[]>([]);
    private readonly inAppErrorMessages = signal<CriticalMessage[]>([]);

    getMessages(): Observable<Message[]> {
        return this.messageApiService.getMessages().pipe(
            filter((messages) => !!messages),
            tap((messages) => this.setMessages(messages))
        );
    }

    getInAppErrorMessages(): Signal<CriticalMessage[]> {
        return this.inAppErrorMessages.asReadonly();
    }

    getBannerMessages(): Signal<Message[]> {
        return this.bannerMessages.asReadonly();
    }

    getNotifyMessages(): Signal<Message[]> {
        return this.notifyMessages.asReadonly();
    }

    setInAppErrorMessages(messages: CriticalMessage[]): void {
        this.inAppErrorMessages.set(messages);
    }

    private setMessages(messages: Message[]): void {
        this.bannerMessages.set(messages.filter((m) => m.type === 'BANNER'));
        this.notifyMessages.set(messages.filter((m) => m.type === 'NOTIFY'));
    }
}
